/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreateIteroScanRequestAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CreateIteroScanRequestAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/ImportAction/Content/CreateIteroScanRequestAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appPropertiesIteroEnabledValueData = fromData.useDataValue({ viewPath,
context: 'app_properties',
path: 'itero_enabled',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(appPropertiesIteroEnabledValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}